var _a;
import { generateApi } from "../generators/generator.api";
import { GENERATOR_PARAMS } from "./report.beneficiary.constants";
export var FETCH_LIMIT = 50;
export var getPagedOld = (_a = generateApi(GENERATOR_PARAMS), _a.getPaged), getCount = _a.getCount;
